import { Components, Theme } from '@mui/material'

const MuiInput: Components<Theme>['MuiInput'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: 14,
      gap: 8,
      height: 48,
      background: theme.backgrounds.backgroundFour,
      border: `1px solid ${theme.backgrounds.backgroundOne}`,
      boxShadow: theme.boxShadows.small,
      borderRadius: 14,

      '&.MuiInputBase-colorSecondary': {
        border: `1px solid ${theme.backgrounds.backgroundThree}`,
        background: theme.backgrounds.backgroundThree,
      },
      '&.MuiInputBase-sizeSmall': {
        padding: 8,
        height: 36,
        borderRadius: 8,
      },
      '&.MuiInputBase-multiline': {
        height: 84,
        alignItems: 'normal',
        overflowY: 'scroll',
      },
      '.MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
      '&.Mui-focused': {
        border: `1px solid ${theme.colors.blue}`,
      },
      '&.Mui-error': {
        border: `1px solid ${theme.colors.red}`,
      },
      '.MuiInputAdornment-root': {
        marginRight: 0,

        '.MuiSvgIcon-root': {
          width: 22,
          height: 22,
        },
      },
      '&::before': {
        borderBottom: 'none',
      },
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    }),
    input: ({ theme }) => ({
      padding: 0,
      fontFamily: theme.fonts.family.PlusJakartaSans,
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '20px',
      color: theme.typographyColors.typographyTwo,

      '&::placeholder': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        fontWeight: 400,
        fontSize: 16,
        lineHeight: '20px',
        color: theme.typographyColors.typographyThree,
        opacity: 1,
      },
    }),
  },
}

export default MuiInput
